import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Panel, FormRow, Input, DollarAdornment } from 'modules/core/components';
import { FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES } from 'modules/RACAffordabilityEngine/const/fieldNames.const';
import { FormControlFeedback } from 'components/Modals/LoanVariablesDialog/styles';
import { EMPTY_STRING } from 'modules/core/constants';
import { useFormContext } from 'react-hook-form';
import { useRenderFields } from 'modules/core/hooks';
import { IField } from 'modules/core/types';

interface IVscGapLimitResult {
  message: string;
  isInvalid: boolean;
}

interface ILenderSettingsContentProps {
  backAddsLimit: IVscGapLimitResult;
  gapLimit: IVscGapLimitResult;
  isDisabled: (name: string) => boolean;
  fieldsConfig: IField[];
}

export const LenderSettingsContent: FC<ILenderSettingsContentProps> = ({
  backAddsLimit,
  gapLimit,
  isDisabled,
  fieldsConfig,
}) => {
  const { t } = useTranslation();
  const {
    formState: { touched },
  } = useFormContext();
  const fields = useRenderFields(fieldsConfig, touched, false);

  return (
    <Panel title={EMPTY_STRING}>
      <FormRow
        label={t('components.frontAndBackEndsAddsModal.addOns')}
        isVerticalAlign
        control={
          <Input
            name={FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.ADD_ONS}
            hideInitZeroValue
            decimalScale={0}
            placeholder={t('components.input.placeholders.integer')}
            startAdornment={<DollarAdornment />}
          />
        }
      />
      <FormRow
        label={t('components.frontAndBackEndsAddsModal.backEnd')}
        isVerticalAlign
        control={
          <>
            <Input
              name={FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.VSC}
              disabled={isDisabled(FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.VSC)}
              isInvalid={backAddsLimit.isInvalid}
              hideInitZeroValue
              decimalScale={0}
              placeholder={t('components.input.placeholders.integer')}
              startAdornment={<DollarAdornment />}
            />
            {backAddsLimit.message && (
              <FormControlFeedback type="invalid" className="d-block" $isInvalid={backAddsLimit.isInvalid}>
                {backAddsLimit.message}
              </FormControlFeedback>
            )}
          </>
        }
      />
      {!isDisabled(FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.GAP) && (
        <FormRow
          label={t('components.frontAndBackEndsAddsModal.gap')}
          isVerticalAlign
          control={
            <>
              <Input
                name={FRONT_AND_BACK_ENDS_ADDS_FIELD_NAMES.GAP}
                isInvalid={gapLimit.isInvalid}
                hideInitZeroValue
                decimalScale={0}
                placeholder={t('components.input.placeholders.integer')}
                startAdornment={<DollarAdornment />}
              />
              {gapLimit.message && (
                <FormControlFeedback type="invalid" className="d-block" $isInvalid={gapLimit.isInvalid}>
                  {gapLimit.message}
                </FormControlFeedback>
              )}
            </>
          }
        />
      )}
      {fields}
    </Panel>
  );
};
